<template>
  <div>
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请选择"  maxlength="50" show-word-limit/>
    </el-form-item>
    <el-form-item label="日期格式">
      <el-select size="small" v-model="value.format" class="width-100">
        <!-- <el-option value="yyyy" label="年"></el-option> -->
        <!-- <el-option value="yyyy-MM" label="年-月"></el-option> -->
        <el-option value="yyyy-MM-dd" label="年-月-日"></el-option>
        <el-option value="yyyy-MM-dd HH:mm:ss" label="年-月-日 时:分:秒"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "DateTime",
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.width-100 {
  width: 100%;
}
</style>
